import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card-expand-icon',
  templateUrl: './card-expand-icon.component.html',
  styleUrls: ['./card-expand-icon.component.scss'],
  animations: [
    trigger('rotate', [
      state('open', style({ transform: 'rotate(0)' })),
      state('close', style({ transform: 'rotate(-180deg)' })),
      transition('open <=> close', animate('150ms ease-out')),
    ]),
  ],
})
export class CardExpandIconComponent {
  @Input() open = true;
}
